import React from 'react';
import { MessageSquare } from 'lucide-react';
import { Card } from '../../atoms/Card';

export const ModerationPage = () => {
  return (
    <div className="p-4 sm:p-6 lg:p-8 bg-gradient-to-br from-gray-50 to-white min-h-screen">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <MessageSquare className="w-8 h-8 text-accent" />
          <h1 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
            Moderasyon
          </h1>
        </div>
        <p className="text-gray-600 text-base sm:text-lg">
          Yorumları ve içerikleri moderasyon yapın
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card title="Bekleyen Yorumlar">
          <p className="text-sm text-gray-600">
            Onay bekleyen yorumlar burada görünecek...
          </p>
        </Card>

        <Card title="Onaylanmış Yorumlar">
          <p className="text-sm text-gray-600">
            Onaylanmış yorumlar burada görünecek...
          </p>
        </Card>

        <Card title="Reddedilen Yorumlar">
          <p className="text-sm text-gray-600">
            Reddedilen yorumlar burada görünecek...
          </p>
        </Card>
      </div>
    </div>
  );
};

